import React from 'react';
import { Checkbox as AntdCheckbox } from 'antd';
import { cn } from '@/helpers/util';

export default function Checkbox({ className, ...rest }) {
  return (
    <AntdCheckbox className={cn(className)} {...rest} />
  );
}
